import { Directive } from '@angular/core';
import { FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appDateValidation]'
})
export class DateValidationDirective {

  constructor() { }

}

export function dateValidator(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
      let frDate = form.controls['fromDate'].value;
      if (frDate) {
        if (frDate >= control.value) {
          return { 'dateValidation': { value: control.value } };
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
}

